// Turn an axios error into a small, user-safe payload for rejectWithValue.
// Never forward a raw response body: proxies, Heroku routers and dev servers
// answer failures with full HTML pages, which the UI would then print verbatim.

const STATUS_MESSAGES = {
  404: 'We couldn\u2019t find what you were looking for.',
  429: 'Too many requests. Please wait a moment and try again.',
  500: 'Our server ran into a problem. Please try again shortly.',
  502: 'Deals are temporarily unavailable. Please try again shortly.',
  503: 'Deals are temporarily unavailable. Please try again shortly.',
  504: 'The server took too long to respond. Please try again.',
};

const GENERIC_MESSAGE = 'Something went wrong while loading deals. Please try again.';
const NETWORK_MESSAGE = 'Can\u2019t reach Lite Pocket Deals right now. Check your connection and try again.';
const MAX_MESSAGE_LENGTH = 200;

const looksLikeHtml = (text) => /<\s*(!doctype|html|head|body|[a-z][a-z0-9]*[\s>/])/i.test(text);

// A server-provided message is shown only if it is short plain text.
export const isDisplayableMessage = (text) =>
  typeof text === 'string'
  && text.trim().length > 0
  && text.length <= MAX_MESSAGE_LENGTH
  && !looksLikeHtml(text);

export const toApiError = (error) => {
  const response = error?.response;
  if (!response) {
    return { error: NETWORK_MESSAGE };
  }

  const { status, data } = response;
  const serverMessage = data && typeof data === 'object' ? (data.error || data.message) : null;
  if (isDisplayableMessage(serverMessage)) {
    return { error: serverMessage, status };
  }

  return { error: STATUS_MESSAGES[status] || GENERIC_MESSAGE, status };
};

export default toApiError;
